<template>
<div class="input__wrapper">
 <input type="text" class="input__text" v-model="paragraph" placeholder="paragraph">
   <DeleteButton :index="index" />
</div> 
</template>

<script setup>
import DeleteButton from '@/components/PopUp/DeleteButton.vue'
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String,
    index:Number
})

const paragraph = fieldFactory('paragraph', props.popStoreId)
</script>

<style>

</style>